var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestWithdrawn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_waiting-for-keys") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 4,
    height: 32,
    rx: 1.73,
    ry: 1.73,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 20,
    height: 14,
    fill: "#c02e1d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 20,
    height: 14,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2,
    width: 19,
    height: 14,
    fill: "#c02e1d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 4,
    height: 14,
    transform: "translate(10 18) rotate(180)",
    fill: "#c02e1d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 4,
    height: 14,
    transform: "translate(10 18) rotate(180)",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestWithdrawn);
export default __webpack_public_path__ + "static/media/request_withdrawn.c3a436d4d1414609bb775b49b20a963a.svg";
export { ForwardRef as ReactComponent };